export const wait = async (waitTime) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, waitTime)
  })
}